import { render } from "./AgendaCard.vue?vue&type=template&id=803183d2&scoped=true"
import script from "./AgendaCard.vue?vue&type=script&lang=js"
export * from "./AgendaCard.vue?vue&type=script&lang=js"

import "./AgendaCard.vue?vue&type=style&index=0&id=803183d2&scoped=true&lang=scss"

import exportComponent from "/opt/buildhome/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-803183d2"]])

export default __exports__